import { render, staticRenderFns } from "./option.vue?vue&type=template&id=370a5cca&scoped=true&lang=pug"
import script from "./option.vue?vue&type=script&lang=js"
export * from "./option.vue?vue&type=script&lang=js"
import style0 from "./option.vue?vue&type=style&index=0&id=370a5cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370a5cca",
  null
  
)

export default component.exports